import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';

// common
import { SubscriberComponent, IApiResponse, AdviceDoc } from '@aa/common';

// shared
import { SelfServAnalyticsService, SelfServMetaCache } from '../../services';
import { SelfServEmailRequest } from '../../models';

const url = '/api/selfserv/share/email';

@Component({
  selector: 'aa-email-advice',
  templateUrl: './email-advice.component.html',
  styleUrls: ['./email-advice.component.scss']
})
export class EmailAdviceComponent extends SubscriberComponent implements OnInit {

  @Input() adviceDoc: AdviceDoc;

  public email: string = null;
  public progress: boolean = false;
  public sent: boolean = false;
  public feedback: string = null;

  public readonly form: FormGroup;

  constructor(private readonly http: HttpClient,
              private readonly analytics: SelfServAnalyticsService,
              private readonly metaCache: SelfServMetaCache) {
    super();

      this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email])
    });

    // clear email feedback if form is changed
    super.subscribe(this.form.valueChanges, () => {
      this.feedback = null;
      this.sent = false;
    });
  }

  ngOnInit() {
    if (!this.adviceDoc) {
      throw Error('adviceDoc not defined');
    }
  }

  public enableForm() {
    this.progress = false;
  }

  public submit() {
    const email = this.form.value.email;
    this.progress = true;

    const data = {
      email: email,
      configId: this.metaCache.meta.configId,
      adviceId: this.adviceDoc.adviceId,
    } as SelfServEmailRequest;

    this.http.post<IApiResponse>(url, data).subscribe(res => {
      this.feedback = `Email sent to ${email}`;
      this.progress = false;
      this.sent = true;
      this.analytics.trackEmailExport(this.adviceDoc);
    }, err => {
      this.progress = false;
      this.feedback = `Failed to send email. Please check your connection and try again`;
      this.analytics.trackEmailError(this.adviceDoc, err);
    });
  }
}
